{
  "name": "@getcronit/pylon",
  "version": "3.0.0-canary-20260508115545.74ba3bff3f7ade973010148205bb756b3e5642cc",
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index.d.ts",
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./pages": {
      "import": "./dist/pages/index.js",
      "types": "./dist/pages/index.d.ts"
    },
    "./pages/index.css": {
      "import": "./dist/pages/index.css"
    },
    "./tsconfig.pylon.json": "./tsconfig.pylon.json"
  },
  "scripts": {
    "build": "rimraf ./dist && node build.js && pnpm run build:declarations",
    "build:declarations": "tsc --declaration --emitDeclarationOnly --outDir ./dist && tsc-alias"
  },
  "files": [
    "dist",
    "tsconfig.pylon.json"
  ],
  "author": "Nico Schett <nico.schett@cronit.io>",
  "license": "Apache-2.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/getcronit/pylon.git",
    "directory": "packages/pylon"
  },
  "homepage": "https://pylon.cronit.io",
  "dependencies": {
    "@envelop/core": "^5.0.3",
    "@gqty/react": "^3.1.0",
    "@graphql-tools/delegate": "^12.0.9",
    "@graphql-tools/executor-http": "^3.1.0",
    "@graphql-tools/wrap": "^11.1.9",
    "@graphql-yoga/plugin-disable-introspection": "^2.13.0",
    "@hono/sentry": "^1.2.0",
    "@radix-ui/react-collapsible": "^1.1.3",
    "@radix-ui/react-slot": "^1.1.2",
    "@sentry/bun": "^8.17.0",
    "@sentry/node": "^8.54.0",
    "@sentry/react": "^10.5.0",
    "chokidar": "^4.0.3",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "consola": "^3.2.3",
    "escape-string-regexp": "^5.0.0",
    "gqty": "3.4.0-canary-20250207102900.644ad9fdeafa6318516627577b1d4d754d5c5a98",
    "graphql": "^16.9.0",
    "graphql-scalars": "^1.24.0",
    "graphql-yoga": "^5.6.2",
    "hono": "^4.0.8",
    "jsonwebtoken": "^9.0.2",
    "lucide-react": "^0.474.0",
    "mime": "^4.0.6",
    "mitt": "^3.0.1",
    "openid-client": "^6.1.7",
    "postcss-load-config": "^6.0.1",
    "react-router": "^7.1.5",
    "sharp": "^0.33.5",
    "tailwind-merge": "^3.0.1",
    "tiny-glob": "^0.2.9",
    "toucan-js": "^4.1.0"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "devDependencies": {
    "@sentry/types": "^8.54.0",
    "@tailwindcss/postcss": "^4.0.6",
    "@types/react": "^19.0.8",
    "@types/react-dom": "^19.0.4",
    "tailwindcss": "^4.0.4",
    "tailwindcss-animate": "^1.0.7",
    "ts-morph": "^28.0.0",
    "tsc-alias": "^1.8.11",
    "vitest": "^2.0.0"
  },
  "peerDependencies": {
    "@tailwindcss/postcss": "^4.0.4",
    "autoprefixer": "^10.4.20",
    "postcss": "^8.5.1",
    "react": "^19.0.0",
    "react-dom": "^19.0.0"
  },
  "peerDependenciesMeta": {
    "react": {
      "optional": true
    },
    "react-dom": {
      "optional": true
    },
    "@tailwindcss/postcss": {
      "optional": true
    },
    "autoprefixer": {
      "optional": true
    }
  }
}
